import Vue from 'vue'
import Router from 'vue-router'
import home from '@/components/home.vue'
import login from '@/components/login.vue'
import index from '@/components/index/index'
import cluelist from '@/components/resources/cluelist'
import cluedetail from '@/components/resources/cluedetail'
import clueinvalid from '@/components/resources/clueinvalid'
import customlist from '@/components/resources/customlist'
import cluefollow from '@/components/resources/cluefollow'
import customdetail from '@/components/resources/customdetail'
import orderlist from '@/components/order/orderlist'
import orderdetail from '@/components/order/orderdetail'
import goodslist from '@/components/order/goodslist'
import msglog from '@/components/order/msglog'
import financelist from '@/components/finance/financelist'
import refundlist from '@/components/finance/refundlist'
import allocation from '@/components/system/allocation'
import person from '@/components/system/person'
import rolelist from '@/components/system/rolelist'
import menulist from '@/components/system/menulist'
import setsite from '@/components/system/setsite'

import project from '@/components/system/project'
import projecttype from '@/components/system/projecttype'
import setcost from '@/components/system/setcost'
import reasonlist from '@/components/system/reasonlist'
import pwdstyle from '@/components/system/pwdstyle'
import cardlist from '@/components/card/cardlist'
import userlist from '@/components/user/userlist'
import adduser from '@/components/user/adduser'
import edituser from '@/components/user/edituser'
import cluesea from '@/components/cluelog/cluesea'
import cluetype from '@/components/cluelog/cluetype'
import cluesource from '@/components/cluelog/cluesource'
import clueslevel from '@/components/cluelog/clueslevel'
import customsea from '@/components/cluelog/customsea'
import fplog from '@/components/cluelog/fplog'
import tellist from '@/components/traffic/tellist'
import timelist from '@/components/traffic/timelist'
import datalist from '@/components/traffic/datalist'
import chatpage from '@/components/chat/chatpage'

import wxmenu from '@/components/chat/wxmenu'
import reply from '@/components/chat/reply'
import wximg from '@/components/chat/wximg'
import chatlog from '@/components/chat/chatlog'
import settime from '@/components/chat/settime'



Vue.use(Router)

const router=new Router({
  mode: 'history',
  routes: [
    {path: '/login',name: 'login',component: login},
    {
      name:'home',path: '/', component: home, 
      children: [
        {name:'index',path:'index',component:index},
        {name:'settime',path:'settime',component:settime},
        {name:'chatlog',path:'chatlog',component:chatlog},
        {name:'wximg',path:'wximg',component:wximg},
        {name:'reply',path:'reply',component:reply},
        {name:'wxmenu',path:'wxmenu',component:wxmenu},
        {name:'msglog',path:'msglog',component:msglog},
        {name:'chatpage',path:'chatpage',component:chatpage},
        {name:'projecttype',path:'projecttype',component:projecttype},
        {name:'goodslist',path:'goodslist',component:goodslist},
        {name:'reasonlist',path:'reasonlist',component:reasonlist},
        {name:'datalist',path:'datalist',component:datalist},
        {name:'refundlist',path:'refundlist',component:refundlist},
        {name:'pwdstyle',path:'pwdstyle',component:pwdstyle},
        {name:'cluefollow',path:'cluefollow',component:cluefollow},
        {name:'cluelist',path:'cluelist',component:cluelist},
        {name:'setsite',path:'setsite',component:setsite},
        {name:'clueinvalid',path:'clueinvalid',component:clueinvalid},
        {name:'cluedetail',path:'cluedetail',component:cluedetail},
        {name:'customlist',path:'customlist',component:customlist},
        {name:'customdetail',path:'customdetail',component:customdetail},
        {name:'orderlist',path:'orderlist',component:orderlist},
        {name:'orderdetail',path:'orderdetail',component:orderdetail},
        {name:'financelist',path:'financelist',component:financelist},
        {name:'allocation',path:'allocation',component:allocation},
        {name:'cardlist',path:'cardlist',component:cardlist},
        {name:'userlist',path:'userlist',component:userlist},
        {name:'adduser',path:'adduser',component:adduser},
        {name:'edituser',path:'edituser',component:edituser},
        {name:'cluesea',path:'cluesea',component:cluesea},
        {name:'customsea',path:'customsea',component:customsea},
        {name:'fplog',path:'fplog',component:fplog},
        {name:'tellist',path:'tellist',component:tellist},
        {name:'timelist',path:'timelist',component:timelist},
        {name:'project',path:'project',component:project},
        {name:'rolelist',path:'rolelist',component:rolelist},
        {name:'menulist',path:'menulist',component:menulist},
        {name:'setcost',path:'setcost',component:setcost},
        {name:'cluetype',path:'cluetype',component:cluetype},
        {name:'cluesource',path:'cluesource',component:cluesource},
        {name:'clueslevel',path:'clueslevel',component:clueslevel},
        {name:'person',path:'person',component:person}
      ],
      redirect: {path: '/index' },
    }]
})

router.beforeEach((to, from, next) => {
  console.log("token="+localStorage.getItem('token'))
  if (localStorage.getItem('token')) {
    next();
  }else{
      //没有登录，去跳转登录页
      if(to.path === '/login'){
        next();
      }else {
        next({
          path:'/login'
        });
      }
  }
})

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js